import { COUNTERPARTIES } from "./action";

const initialState = {
  counterPartyList: [],
  onboardCounterPartyList: [],
  partyCreated: {},
  selectedParty: {},
  partyUpdated: {},
  orderFetchComplete:true,
  connections:[],
  orderConnectionFetchComplete:false
};

export default function counterPartyReducer(state = initialState, action) {
  switch (action.type) {
    case COUNTERPARTIES.getCounterpartList.success:
      return {
        ...state,
        counterPartyList: action.data,
        partyCreated: {},
        partyUpdated: {}
      };
      case COUNTERPARTIES.getOrderCounterpartList.success:
        return {
          ...state,
          onboardCounterPartyList: action.data,
          orderFetchComplete:true
        };
        case COUNTERPARTIES.getFarmerConnectiontList.success:
          return {
            ...state,
            connections: action.data,
            orderConnectionFetchComplete:true
          };
    case COUNTERPARTIES.create.success:
      return {
        ...state,
        partyCreated: action.data
      };
    case COUNTERPARTIES.edit.success:
      return {
        ...state,
        selectedParty: action.data
      };
    case COUNTERPARTIES.update.success:
      return {
        ...state,
        partyUpdated: action.data
      };
    case COUNTERPARTIES.delete.success:
      const partyId = action.data.id;
      return {
        ...state,
        counterPartyList: state.counterPartyList.filter(
          party => party.id !== partyId
        )
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/counterparties/reducer.js